import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("userData");
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [userId, setUserId] = useState(() => {
    const savedUserId = localStorage.getItem("userId");
    return savedUserId ? JSON.parse(savedUserId) : null;
  });

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem("userData", JSON.stringify(userData));
  };

  const loginUserId = (userId) => {
    console.log("Setting userId in AuthContext:", userId);
    setUserId(userId);
    localStorage.setItem("userId", JSON.stringify(userId));
  };

  const logoutUserId = () => {
    setUserId(null);
    localStorage.removeItem("userId");
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("userData");
  };

  useEffect(() => {
    const savedUser = localStorage.getItem("userData");
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, login, logout, userId, loginUserId, logoutUserId }}
    >
      {children}
    </AuthContext.Provider>
  );
};
